(() => {
  function initializeCart(root = document) {
    root.querySelectorAll('[data-cart-form]').forEach(form => {
      if (form.dataset.cartReady) return;
      form.dataset.cartReady = 'true';
      let submitting = false;
      const submitUpdate = async input => {
        if (submitting) return;
        submitting = true;
        const line = Number.parseInt(input.closest('[data-cart-line]')?.dataset.cartLine, 10);
        const quantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
        form.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(form.dataset.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line, quantity })
          });
          if (!response.ok) throw new Error('Cart update failed');
          location.reload();
        } catch (error) {
          form.removeAttribute('aria-busy');
          submitting = false;
          const message = form.querySelector('[data-cart-error]');
          if (message) { message.hidden = false; message.textContent = 'We could not update your bag. Please try again.'; }
        }
      };
      form.addEventListener('click', event => {
        const button = event.target.closest('[data-cart-increase],[data-cart-decrease]');
        if (!button || !form.contains(button)) return;
        const input = button.closest('[data-cart-quantity]')?.querySelector('[data-cart-input]');
        if (!input) return;
        const current = Math.max(1, Number.parseInt(input.value, 10) || 1);
        input.value = Math.max(1, current + (button.hasAttribute('data-cart-increase') ? 1 : -1));
        submitUpdate(input);
      });
      form.addEventListener('change', event => {
        if (!event.target.matches('[data-cart-input]')) return;
        event.target.value = Math.max(1, Number.parseInt(event.target.value, 10) || 1);
        submitUpdate(event.target);
      });
    });
  }
  document.addEventListener('DOMContentLoaded', () => initializeCart());
  document.addEventListener('shopify:section:load', event => initializeCart(event.target));
})();
